export const WagBusiness = {
  HeaderText: 'header-text',
  SubHeaderText: 'sub-header-text',
  LaunchPaymentFlowCta: 'launch-payment-flow-cta',
};
